import React, { Component } from 'react';
import { Link } from 'gatsby';
import { Match } from '@reach/router';

import { Sponsors } from 'components';
import { Icon } from 'elements';
import { classnames, classname } from 'utils';

import './Header.css';

class Header extends Component {
  cl = classname('header');

  render() {
    const { className } = this.props;

    const classes = classnames(className, this.cl());

    return (
      <header className={classes}>
        <div className={this.cl('wrapper')}>
          <div className={this.cl('inner')}>
            <div className={this.cl('bottom')}>
              <div className={this.cl('title')}>
                <div className={this.cl('title-small')}>
                  Лидеры интегрального рейтинга Technology Index 2020 и&nbsp;партнёры проекта
                </div>
                <Match path={'*'}>
                  {({ match }) => {
                    if (match['*']) {
                      return (
                        <Link to="/" className={this.cl('title-main')}>
                          Technology Map
                          <span className={this.cl('title-main-addition')}> 2020</span>
                        </Link>
                      );
                    } else {
                      return (
                        <div className={this.cl('title-main')}>
                          Technology Map
                          <span className={this.cl('title-main-addition')}> 2020</span>
                        </div>
                      );
                    }
                  }}
                </Match>
              </div>

              <a href={"https://maps.adindex.ru"} target={"_blank"} className={this.cl('logo')}>
                <div className={this.cl('logo-maintext')}>
                  <Icon name={'logo'} size={'fit'} />
                </div>
                <div className={this.cl('logo-addition')}>
                  <Icon name={'logoMaps'} />
                </div>
              </a>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;
